import { render, staticRenderFns } from "./backHome.vue?vue&type=template&id=010c1f13&scoped=true"
import script from "./backHome.vue?vue&type=script&lang=js"
export * from "./backHome.vue?vue&type=script&lang=js"
import style0 from "./backHome.vue?vue&type=style&index=0&id=010c1f13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c1f13",
  null
  
)

export default component.exports